import { createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = '/file';

export const uploadImages = createAsyncThunk(
  'uploadImages',
  async (payload, { rejectWithValue }) => {
    try {
      const { data, status } = await apiConfig.post(URL, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (status !== 200) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
